import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = {
  id: "progress-gradient",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%"
}
const _hoisted_3 = ["stop-color"]
const _hoisted_4 = ["stop-color"]
const _hoisted_5 = ["stroke-width", "stroke", "r", "stroke-dasharray"]
const _hoisted_6 = ["stroke-width", "r", "stroke-dasharray", "stroke-dashoffset"]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressRing',
  props: {
  percentage: {
    type: Number,
    required: true,
    default: 0,
  },
  size: {
    type: [Number, String],
    required: true,
    default: 100,
  },
  strokeWidth: {
    type: Number,
    default: 3,
  },
  backgroundColor: {
    type: String,
    default: '#e6e6e6',
  },
  foregroundColor: {
    type: String,
    default: '#5BB97B',
  },
},
  setup(__props) {

const props = __props;



const radius = computed(() => 10);
const cx = '50%';
const cy = '50%';
const viewBox = '0 0 26 26';

const circumference = computed(() => 2 * Math.PI * radius.value);

const dashOffset = computed(() => circumference.value - (props.percentage / 100) * circumference.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: viewBox
  }, [
    _createElementVNode("linearGradient", _hoisted_2, [
      _createElementVNode("stop", {
        offset: "0%",
        "stop-color": __props.foregroundColor
      }, null, 8, _hoisted_3),
      _createElementVNode("stop", {
        offset: "100%",
        "stop-color": __props.foregroundColor
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("circle", {
      "stroke-width": __props.strokeWidth,
      stroke: __props.backgroundColor,
      fill: "transparent",
      r: _unref(radius),
      cx: cx,
      cy: cy,
      "stroke-dasharray": _unref(circumference)
    }, null, 8, _hoisted_5),
    _createElementVNode("circle", {
      class: "origin-[50%_50%]",
      "stroke-width": __props.strokeWidth,
      fill: "transparent",
      r: _unref(radius),
      cx: cx,
      cy: cy,
      stroke: "url(#progress-gradient)",
      "stroke-linecap": "round",
      "stroke-dasharray": _unref(circumference),
      "stroke-dashoffset": _unref(dashOffset),
      style: {"transform":"rotate(-90deg)"}
    }, null, 8, _hoisted_6)
  ], 8, _hoisted_1))
}
}

})